/** Unwrap Stride `{ success, data }` envelopes */
export function unwrapPayload(data: unknown): Record<string, unknown> {
  if (!data || typeof data !== 'object') return {}
  const root = data as Record<string, unknown>
  const inner = root.data
  if (inner && typeof inner === 'object' && !Array.isArray(inner)) {
    return inner as Record<string, unknown>
  }
  return root
}
